import script from "./Sparkle.vue?vue&type=script&setup=true&lang=js"
export * from "./Sparkle.vue?vue&type=script&setup=true&lang=js"

import "./Sparkle.vue?vue&type=style&index=0&id=146c5c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146c5c9c"]])

export default __exports__